<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 mx-auto container-xl">
      <div class="title-area">
        <h1 class="page-title h2 mb-2">Tutorials</h1>
      </div>
      <b-table
        id="tutorials"
        ref="tutorials"
        hover
        :items="tutorials"
        :fields="fields"
        @row-clicked="viewtutorial"
      >
        <template v-slot:cell(empty)="data">
          <fa-icon name="film" />
        </template>
        <template v-slot:cell(actions)="data">
          <div class="d-flex justify-content-end">
            <b-dropdown right class="ml-2">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <b-dropdown-item @click.prevent="viewtutorial(data.item);">
                View
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

const fields = [
  { key: 'tutorial_heading', label: 'Tutorial', sortable: true },
  // { key: 'empty', label: '', sortable: false, tdClass: 'align-left text-left' },
  { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
]

export default {
  name: 'Tutorials',
  components: {
    Navbar,
    Breadcrumb
  },
  data: function () {
    return {
      tutorials: [],
      fields: fields
    }
  },
  created () {
    this.tutorials_get()
  },
  methods: {
    tutorials_get () {
      this.$store.dispatch('tutorials_fetch')
        .then((resp) => {
          this.tutorials = resp.data.result
        })
    },
    viewtutorial (item) {
      this.$store.dispatch('tutorial_setcurrent', { tutorial_id: item.id })
        .then(() => {
          this.$router.push('/tutorial')
        })
    }
  }
}
</script>
<style>
</style>
